/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { classNames } from '../../../utils';
import { SchoolService } from '../../../services'
import { useDispatch, useSelector } from 'react-redux';
import SubjectStep from './subject-step';
import ScheduleStep from './schedule-step';
import { IconArrowLeft } from '@tabler/icons-react';

const STEP = {
  SUBJECTS: 1,
  SCHEDULE: 2,
}

const ModalCreateSchedule = ({ item, onSuccess, onClose, grades, schoolYears }) => {
  const dispatch = useDispatch()
  const [step, setStep] = useState(item ? STEP.SCHEDULE : STEP.SUBJECTS);
  const scheduler = useSelector(state => state.scheduler);
  const user = useSelector(state => state.user);


  const onSubmit = async () => {
    try {
      const data = { ...scheduler, school_id: user.id }
      item
        ? await SchoolService.schoolAdmin.updateSchedule(data)
        : await SchoolService.schoolAdmin.createSchedule(data);
      toast.success('Horarios creados correctamente');
      dispatch({ type: 'REMOVE_DATA' });
      onSuccess()
    } catch (error) {
      toast.error(String(error));
    }
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{item ? 'Editar' : 'Nuevo'}</ModalHeader>

      {step === STEP.SCHEDULE && !item && (
        <div
          className="relative left-4 cursor-pointer"
          onClick={() => setStep(STEP.SUBJECTS)}
        >
          <IconArrowLeft />
        </div>
      )}
      <ModalBody className='gap-8'>
        <div className="flex flex-row items-start gap-4">
          <div className="flex-1 text-center gap-2">
            <div className="text-sm font-semibold mb-2">Asignar materias</div>
            <div className="h-[6px] rounded bg-primary" />
          </div>
          <div className="flex-1 text-center gap-2">
            <div className="text-sm font-semibold mb-2">Asignar horarios</div>
            <div className={classNames('h-[6px] rounded', step === STEP.SCHEDULE ? 'bg-primary' : 'bg-gray')} />
          </div>
        </div>


        {step === STEP.SUBJECTS && (
          <SubjectStep
            grades={grades}
            schoolYears={schoolYears}
          />
        )}

        {step === STEP.SCHEDULE && (
          <ScheduleStep
            item={item}
          />
        )}
      </ModalBody>

      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        {step === STEP.SUBJECTS ? (
          <>
            <Button
              className="bg-green"
              color="primary"
              onPress={() => setStep(STEP.SCHEDULE)}
              isDisabled={scheduler?.subjects?.filter(x => x.isSelected).length < 1}
            >
              Asignar horarios
            </Button>
          </>
        ) : (

          <Button className="bg-green" color="primary" onPress={onSubmit}>Guardar</Button>
        )}
      </ModalFooter>
    </>
  )
}




export default ModalCreateSchedule;
